import React from "react";

const RegionalResults = () => {
  return (
    <div style={{ padding: "24px" }}>
      <h2>RESULTS</h2>
    </div>
  );
};

export default RegionalResults;
